module.exports = __webpack_public_path__ + "static/media/call-center3.4c1b4f57.png";